module.exports = __webpack_public_path__ + "static/img/preloader.68d2037.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preloader.gif
// module id = 5va1
// module chunks = 0